import { render, staticRenderFns } from "./CustomerListHandler.vue?vue&type=template&id=5fc73da7"
import script from "./CustomerListHandler.vue?vue&type=script&lang=ts"
export * from "./CustomerListHandler.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports